import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { useMutation, useQuery } from "react-query";
//react-dnd
import { HTML5Backend } from "react-dnd-html5-backend";
import { useDrag, useDrop, DndProvider } from "react-dnd";
//primereact
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { Tooltip } from "primereact/tooltip";
import { Checkbox } from "primereact/checkbox";
import { Skeleton } from "primereact/skeleton";
import { DataTable } from "primereact/datatable";
import { BreadCrumb } from "primereact/breadcrumb";
import { confirmDialog } from "primereact/confirmdialog";
//components
import Panel from "../../../../components/panel/panel";
import Modal from "../../../../components/modal/Modal";
import Input from "../../../../components/input/Input";
import Select from "../../../../components/input/Select";
import ModalStatus from "./ModalStatus";
//services
import { postFunnel } from "../../../../services/Crm/Settings/Funnel/postFunnel";
import { getStatusFunnel } from "../../../../services/Crm/Settings/Status/getStatusFunnel";
import { postAttachStatus } from "../../../../services/Crm/Settings/Status/postAttachStatus";
import { postDetachStatus } from "../../../../services/Crm/Settings/Status/postDetachStatus";
import { deleteStatusFunnel } from "../../../../services/Crm/Settings/Status/deleteStatusFunnel";
import { getFunnelWithStatus } from "../../../../services/Crm/Settings/Funnel/getFunnelWithStatus";
//utils
import { queryClient } from "../../../../utils/queryClient";
import { getContrastColor } from "../../../../utils/getContrastColor";
//context
import { useAppContext } from "../../../../context/AppContext";

const ItemType = "FUNNEL_STEP";

const StatusConfig = () => {
  const form = useForm({ defaultValues: { time: 1 } });
  const errors = form.formState.errors;
  const { permissions } = useAppContext();
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [idFunnel, setIdFunnel] = useState(null);
  const [baseData, setBaseData] = useState(null);
  const [loadingButtonModal, setLoadingButtonModal] = useState(false);
  const [visibleFunnel, setVisibleFunnel] = useState(false);
  const [data, setData] = useState(null);
  const [funnelsOptions, setFunnelsOptions] = useState([]);

  const { data: status, isLoading: isLoadingStatus } = useQuery({
    queryKey: [`statusFunnel`],
    queryFn: () => getStatusFunnel(),
    // enabled: !!permissions?.includes("101")
  });
  // console.log(status);

  const {
    data: funnels,
    isLoading: isLoadingFunnels,
    refetch: refetchFunnels,
    isRefetching: isRefetchingFunnels,
  } = useQuery({
    queryKey: [`funnels`],
    queryFn: () => getFunnelWithStatus(idFunnel),
    onSuccess(data) {
      if (data) {
        form.setValue("funnel", data.data.id);
      }
    },
    refetchOnWindowFocus: false,
    enabled: !!permissions?.includes("230"),
  });
  // console.log(funnels);

  const { mutateAsync: postAttachStatusFn } = useMutation({
    mutationFn: postAttachStatus,
    onSuccess(_, variables) {
      queryClient.setQueryData(["funnels"], (data) => {
        const statusSelected = status.find(
          (item) => item.id === variables.status_id
        );
        const updatedStatus = data.data.status.push(statusSelected);
        const ubdatedData = {
          data: {
            ...data.data,
            status: updatedStatus,
          },
          ...data,
        };
        return ubdatedData;
      });
    },
  });

  const { mutateAsync: postDetachStatusFn } = useMutation({
    mutationFn: postDetachStatus,
    onSuccess(_, variables) {
      queryClient.setQueryData(["funnels"], (data) => {
        const updatedStatus = data.data.status.filter(
          (item) => item.id !== variables.status_id
        );
        const updatedData = {
          ...data,
          data: {
            ...data.data,
            status: updatedStatus,
          },
        };
        return updatedData;
      });
    },
  });

  const { mutateAsync: deleteStatusFunnelFn } = useMutation({
    mutationFn: deleteStatusFunnel,
    onSuccess(res, _) {
      queryClient.setQueryData(["statusFunnel"], (data) => {
        const updatedData = [...data];
        const index = updatedData.findIndex(
          (item) => item.id === res.success.id
        );
        updatedData.splice(index, 1);
        return updatedData;
      });
    },
  });

  const items = [
    {
      template: () => (
        <Link to={"/crm/settings/status"} className="p-breadcrumb-link">
          Configurações de Status
        </Link>
      ),
    },
  ];

  const home = {
    template: () => (
      <Link to={"#"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };

  const columns = [
    {
      field: "status",
      header: "Status",
      body: (rowData) => {
        return (
          <span
            className="badge"
            style={{
              fontSize: "14px",
              marginLeft: "5px",
              backgroundColor: rowData.color,
              color: getContrastColor(rowData.color),
            }}
          >
            {rowData.name}
          </span>
        );
      },
    },
    {
      field: "time",
      header: "Tempo Máximo",
      body: (rowData) => {
        return (
          <span>
            {`${rowData.interval_count} ${
              rowData.interval === "hour" ? "horas" : "dias"
            }`}
          </span>
        );
      },
    },
    ...(permissions?.includes("244")
      ? [
          {
            field: "funnelActive",
            header: "Funil Ativo",
            body: (rowData) => (
              <Checkbox
                checked={funnels?.data?.status?.some(
                  (item) => item.id === rowData.id
                )}
                disabled={loading}
                onChange={(e) => handleChangeFunnelActive(e, rowData)}
              />
            ),
          },
        ]
      : []),
  ];

  const itemTemplate = (option) => {
    return option.label;
  };

  const valueTemplate = (option) => {
    if (option) {
      return option.label;
    }
    return <span>Selecione um Funil</span>;
  };

  const FunnelStep = ({ item, index, moveStep }) => {
    const [{ isDragging }, drag] = useDrag({
      type: ItemType,
      item: { index },
      collect: (monitor) => ({
        isDragging: monitor.isDragging(),
      }),
    });

    const [, drop] = useDrop({
      accept: ItemType,
      // hover: (draggedItem) => {
      //   if (draggedItem.index !== index) {
      //     const updatedData = [...data];
      //     const [movedItem] = updatedData.splice(draggedItem.index, 1);
      //     updatedData.splice(index, 0, movedItem);

      //     updatedData.forEach((item, idx) => {
      //       item.position = idx;
      //     });

      //     setData(updatedData);

      //     // Atualiza o índice do item para evitar múltiplas reordenações
      //     draggedItem.index = index;
      //   }
      // },
      drop: (item) => {
        if (item.index !== index) {
          moveStep({ dragIndex: item.index, dropIndex: index });
        }
      },
    });

    const nextWidthPercentage = 100 - (index + 2) * 1.5;

    return (
      <div
        ref={(node) => drag(drop(node))}
        className={`funnel-step ${isDragging ? "shake" : ""}`}
        style={{
          backgroundColor: item.color,
          color: getContrastColor(item.color),
          width: data
            ? `${Math.max(((data.length - index) / data.length) * 100, 10)}%`
            : "100%",
          opacity: isDragging ? 0.5 : 1,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          clipPath: `polygon(${(100 - nextWidthPercentage) / 2}% 100%, ${
            (100 + nextWidthPercentage) / 2
          }% 100%, 100% 0, 0% 0)`,
        }}
        data-pr-tooltip={item.name}
        data-pr-position="top"
      >
        {item.name}
        {!isDragging && <Tooltip target=".funnel-step" />}
      </div>
    );
  };

  const handleAddFunnel = async (e) => {
    if (e) {
      if (e === "add") {
        setVisibleFunnel(true);
      } else {
        setIdFunnel(e);
        setTimeout(() => {
          refetchFunnels();
        }, [100]);
      }
    }
  };

  const addNewFunnel = async (data) => {
    const notification = toast.loading("Adicionando Funil...");
    setLoadingButtonModal(true);
    try {
      const response = await postFunnel(data);
      setFunnelsOptions([
        ...funnelsOptions,
        { label: data.name, value: response.success.id },
      ]);
      toast.update(notification, {
        render: "Funil adicionado com sucesso!",
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
      setLoadingButtonModal(false);
    } catch (error) {
      toast.update(notification, {
        render: "Erro ao adicionar Funil!",
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
      setLoadingButtonModal(false);
    }
    setVisibleFunnel(false);
  };

  const handleFunnelActiveChange = async (rowData) => {
    setLoading(true);
    // console.log("status_id: ", rowData.id);
    // console.log("funnel_id: ", funnels.data.id);
    const notification = toast.loading("Atualizando Funil...");
    try {
      const response = await postAttachStatusFn({
        status_id: rowData.id,
        funnel_id: funnels.data.id,
      });
      // console.log(response);
      toast.update(notification, {
        render: "Funil atualizado com sucesso!",
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
      setLoading(false);
    } catch (error) {
      toast.update(notification, {
        render: "Erro ao atualizar Funil!",
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
      setLoading(false);
    }
  };

  const handleFunnelInactiveChange = async (rowData) => {
    setLoading(true);
    // console.log("status_id: ", rowData.id);
    // console.log("funnel_id: ", funnels.data.id);
    const notification = toast.loading("Atualizando Funil...");
    try {
      const response = await postDetachStatusFn({
        status_id: rowData.id,
        funnel_id: funnels.data.id,
      });
      // console.log(response);
      toast.update(notification, {
        render: "Funil atualizado com sucesso!",
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
      setLoading(false);
    } catch (error) {
      toast.update(notification, {
        render: "Erro ao atualizar Funil!",
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
      setLoading(false);
    }
  };

  const handleChangeFunnelActive = (e, rowData) => {
    // console.log(e);
    if (e.checked) {
      handleFunnelActiveChange(rowData);
    } else {
      handleFunnelInactiveChange(rowData);
    }
  };

  const onRowReorder = async (e) => {
    // console.log(e);
    const notification = toast.loading("Atualizando Funil...");
    const updatedData = [...data];
    const [movedItem] = updatedData.splice(e.dragIndex, 1);
    updatedData.splice(e.dropIndex, 0, movedItem);

    updatedData.forEach((item, index) => {
      item.position = index;
    });

    setData(updatedData);

    const dataStatus = {
      status_id: movedItem.id,
      funnel_id: funnels.data.id,
      position: e.dropIndex,
    };

    try {
      await postAttachStatus(dataStatus);
      toast.update(notification, {
        render: "Funil atualizado com sucesso!",
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
    } catch (error) {
      const revertedData = [...data];
      const [revertedItem] = revertedData.splice(e.dropIndex, 1);
      revertedData.splice(e.dragIndex, 0, revertedItem);

      revertedData.forEach((item, index) => {
        item.position = index;
      });

      setData(revertedData);

      toast.update(notification, {
        render: "Erro ao atualizar Funil!",
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
    }
  };

  const handleDeleteStatus = async (data) => {
    const notification = toast.loading("Deletando status...");
    try {
      await deleteStatusFunnelFn(data.id);
      toast.update(notification, {
        render: "Status deletado com sucesso!",
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
    } catch (error) {
      toast.update(notification, {
        render: "Erro ao deletar status!",
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
    }
  };

  const handleAcceptDelete = (data) => {
    confirmDialog({
      message: `Tem certeza que deseja excluir o status ${data.name}?`,
      header: "Deletar Status",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Sim",
      rejectLabel: "Não",
      accept: () => handleDeleteStatus(data),
    });
  };

  useEffect(() => {
    const addOption = {
      label: (
        <div className="d-flex align-items-center">
          <i className="fa-solid fa-plus me-2"></i> Adicionar Funil
        </div>
      ),
      value: "add",
    };

    if (funnels?.funnels) {
      const options = funnels.funnels.map((f) => ({
        label: f.name,
        value: f.id,
      }));

      setFunnelsOptions([
        ...options,
        ...(permissions?.includes("231") ? [addOption] : []),
      ]);
    } else {
      setFunnelsOptions(permissions?.includes("231") ? [addOption] : []);
    }
  }, [funnels, permissions]);

  useEffect(() => {
    if (status && funnels?.data?.status) {
      const funnelStatusOrdered = funnels.data.status
        .sort((a, b) => a.pivot.position - b.pivot.position)
        .map((funnelStatus) => {
          const fullStatus = status.find((s) => s.id === funnelStatus.id);
          return fullStatus
            ? { ...fullStatus, pivot: funnelStatus.pivot }
            : null;
        })
        .filter(Boolean); // remove nulos

      const otherStatuses = status.filter(
        (s) => !funnels.data.status.some((f) => f.id === s.id)
      );

      setData([...funnelStatusOrdered, ...otherStatuses]);
    } else if (status) {
      setData(status); // fallback caso não tenha funil ainda
    }
  }, [status, funnels]);

  return (
    <>
      <div className="row justify-content-between mb-3">
        <div className="col-md-12">
          <BreadCrumb model={items} home={home} className="breadCrumb" />
        </div>
      </div>

      <div className="row justify-content-between">
        <div className="col-xl-3 col-md-6">
          <Select
            name="funnel"
            label={isLoadingFunnels ? "Carregando..." : `Funil de vendas`}
            errors={form.formState.errors}
            disabled={isLoadingFunnels}
            itemTemplate={itemTemplate}
            valueTemplate={valueTemplate}
            onChange={handleAddFunnel}
            control={form.control}
            options={funnelsOptions}
          />
        </div>
        <div className="col-xl-6 col-md-6 text-end">
          {permissions?.includes("241") && (
            <Button
              rounded
              label="Adicionar Status"
              icon="pi pi-plus"
              onClick={() => setVisible(true)}
            />
          )}
        </div>
      </div>

      <DndProvider backend={HTML5Backend}>
        <div className="row">
          <div className="col-xl-6 my-2">
            <Panel title="Status" mainCss="h-100">
              <DataTable
                rows={10}
                paginator
                stripedRows
                showGridlines
                reorderableRows
                onRowReorder={onRowReorder}
                editMode="cell"
                sortMode="multiple"
                selectionMode="single"
                rowsPerPageOptions={[10, 25, 100]}
                value={data}
                emptyMessage="Nenhuma Informação foi encontrada."
                tableStyle={{ minWidth: "0.8rem", fontSize: "0.7rem" }}
              >
                <Column rowReorder style={{ width: "3rem" }} />
                {columns.map((col) => (
                  <Column
                    sortable
                    key={col.field}
                    field={col.field}
                    header={col.header}
                    editor={col.editor}
                    body={col.body}
                  />
                ))}
                {permissions?.includes("243") && (
                  <Column
                    header="Editar"
                    body={(rowData) => (
                      <div className="text-center">
                        <Button
                          icon="fa-solid fa-pen-to-square"
                          onClick={() => {
                            setBaseData(rowData);
                            setVisible(true);
                          }}
                        />
                      </div>
                    )}
                  />
                )}
                {permissions?.includes("246") && (
                  <Column
                    header="Excluir"
                    body={(rowData) => (
                      <div className="text-center">
                        <Button
                          icon="fa-solid fa-trash-can"
                          severity="danger"
                          onClick={() => {
                            handleAcceptDelete(rowData);
                          }}
                        />
                      </div>
                    )}
                  />
                )}
              </DataTable>
            </Panel>
          </div>
          <div className="col-xl-6 my-2">
            <Panel title="Funil de vendas" mainCss="h-100">
              {loading || isRefetchingFunnels ? (
                <Skeleton width="100%" height={300} />
              ) : (
                <>
                  <div className="funnel-container">
                    {data
                      ?.filter((status) =>
                        funnels?.data?.status?.some(
                          (statusFunnel) => status.id === statusFunnel.id
                        )
                      )
                      .map((item, index) => (
                        <FunnelStep
                          key={index}
                          index={index}
                          item={item}
                          moveStep={onRowReorder}
                        />
                      ))}
                  </div>
                </>
              )}
            </Panel>
          </div>
        </div>
      </DndProvider>

      <ModalStatus
        visible={visible}
        setVisible={setVisible}
        baseData={baseData}
        setBaseData={setBaseData}
      />

      <Modal
        dynamicTitle="Adicionar Funil"
        position={"top-right"}
        visible={visibleFunnel}
        dynamicWidth={window.innerWidth <= 992 ? "80vw" : "25vw"}
        onHide={() => setVisibleFunnel(false)}
      >
        <form onSubmit={form.handleSubmit(addNewFunnel)}>
          <div className="row">
            <div className="col-md-10 my-4 d-flex align-items-center">
              <Input
                name="name"
                label="Nome do Funil"
                className="w-100"
                //   defaultValue={baseData?.name}
                control={form.control}
                errors={errors}
              />
            </div>
            <div className="row justify-content-end">
              <div className="col-md-6 pt-3 justify-content-end d-flex">
                <Button
                  rounded
                  type="submit"
                  label="Criar"
                  iconPos="right"
                  loading={loadingButtonModal}
                  className="p-inputtext-sm w-100"
                  icon="fa-solid fa-circle-chevron-right"
                />
              </div>
            </div>
          </div>
        </form>
      </Modal>
    </>
  );
};

export default StatusConfig;
